import React, { useRef, useEffect } from "react";
import ChartDataLabels from "chartjs-plugin-datalabels";
import Chart from "chart.js/auto";
import Button from "../../UI/Button";
import moment from "moment";
import { Chart as ChartJS, BarElement } from "chart.js";
import SkeletonRect from "./SkeletonRect";
import { Bar } from "react-chartjs-2";
import { read, utils, writeFile } from "xlsx";

ChartJS.register(BarElement);
const monthRange = [
  "січ",
  "лют",
  "бер",
  "квіт",
  "трав",
  "черв",
  "лип",
  "серп",
  "вер",
  "жовт",
  "лист",
  "груд",
];

const ChartTarrifStructure = (props) => {
  const ref = useRef();

  if (props.consumption === null || props.cost === null) {
    return <SkeletonRect />;
  }

  const data = {
    labels: props.xAvis,
    datasets: [
      {
        label: "Споживання, кВт*год",
        data: props.consumption,
        backgroundColor: "rgba(255, 194, 18, 1)",
        borderRadius: 15,
        maxBarThickness: props.askoe ? 18 : 10,
        pointStyle: "circle",
        yAxisID: "yAxes2",
      },
      {
        label: "Вартість, грн",
        data: props.cost,
        backgroundColor: "rgba(202, 202, 202, 1",
        borderRadius: 15,
        maxBarThickness: 10,
        pointStyle: "circle",
        yAxisID: "yAxes1",
      },
    ],
  };

  const data2 = {
    labels: props.xAvis,
    datasets: [
      {
        label: "Вартість, грн",
        data: props.cost,
        yAxisID: "yAxes1",
      },
    ],
  };

  const data3 = {
    labels: props.xAvis,
    datasets: [
      {
        label: "Споживання, кВт*год",
        data: props.consumption,
        yAxisID: "yAxes2",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 10,
      },
    },
    interaction: {
      intersect: false,
      mode: "index",
    },

    plugins: {
      legend: {
        display: false,
        position: "bottom",
        align: "start",
        labels: {
          usePointStyle: true,
        },
      },
      labels: {
        display: true,
        boxWidth: 14,
        color: "rgba(79, 79, 79, 1)",
        usePointStyle: true,
        padding: {
          bottom: 59,
        },
      },
      tooltip: {
        intersect: false,
        backgroundColor: "rgba(79, 79, 79, 1)",
        borderColor: "rgba(255, 194, 18, 1)",
        borderWidth: 2,
        callbacks: {
          title: function (tooltipItem, data) {
            return (
              tooltipItem[1]
                ? (tooltipItem[1].formattedValue = tooltipItem[1].raw
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, " "))
                : null,
              (tooltipItem[0].formattedValue = tooltipItem[0].raw
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, " ")),
              monthRange.includes(tooltipItem[0].label)
                ? moment().month(tooltipItem[0].dataIndex).format("MMMM")
                : tooltipItem[0].label.split(",").slice(0, 1)
            );
          },
          label: function (tooltipItem) {
            let label = tooltipItem.dataset.label;
            let title = tooltipItem.formattedValue;

            return window.innerWidth < 768
              ? [label, title]
              : label + ": " + title;
          },
        },
      },
    },

    scales: {
      yAxes1: {
        title: {
          display: false,
        },
        grid: {
          display: false,
          drawOnChartArea: false,
          drawBorder: false,
        },
        ticks: {
          display: false,
        },
      },

      yAxes2: {
        title: {
          display: false,
        },
        grid: {
          display: false,
          drawOnChartArea: false,
          drawBorder: false,
        },
        ticks: {
          display: false,
        },
      },

      xAxes: {
        offset: true,

        grid: {
          display: false,
          drawOnChartArea: false,
          lineWidth: 0,
        },
        ticks: {
          maxRotation: 0,
          minRotation: 0,

          display: true,
          color: "rgba(79, 79, 79, 1)",
          font: {
            size: props.groupB ? 14 : 10,
          },
        },
      },
    },
  };

  const options2 = {
    maintainAspectRatio: false,
    layout: {
      padding: {
        bottom: 27,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      yAxes1: {
        type: "linear",
        position: "left",
        beginAtZero: true,
        layout: {
          padding: {
            bottom: 59,
          },
        },
        title: {
          display: window.innerWidth < 1280 ? false : true,
          text: "Вартість, грн",
          color: "rgba(170, 170, 170, 1)",
          font: {
            size: 12,
          },
          padding: { top: -2, left: 0, right: 0, bottom: 0 },
        },
        grid: {
          display: false,
          borderColor: "rgba(170, 170, 170, 1)",
        },

        afterFit: (ctx) => {
          ctx.width = 75;
        },
      },
      xAxes: {
        grid: {
          display: false,
          drawTicks: false,
        },
        ticks: {
          display: false,
        },
      },
    },
  };

  const options3 = {
    maintainAspectRatio: false,
    layout: {
      padding: {
        bottom: 28,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      yAxes2: {
        type: "linear",
        position: "right",
        beginAtZero: true,
        layout: {
          padding: {
            bottom: 59,
          },
        },
        title: {
          display: window.innerWidth < 1280 ? false : true,
          text: "Обсяг кВт*год",
          color: "rgba(170, 170, 170, 1)",
          font: {
            size: 12,
          },
          padding: { top: -2, left: 0, right: 0, bottom: 0 },
        },
        grid: {
          display: false,
          borderColor: "rgba(170, 170, 170, 1)",
        },

        afterFit: (ctx) => {
          ctx.width = 75;
        },
      },
      xAxes: {
        grid: {
          display: false,
          drawTicks: false,
        },
        ticks: {
          display: false,
        },
      },
    },
  };

  const handleExport = () => {
    const xlsHeadings = [[""].concat(props.xAvis)];
    const wb = utils.book_new();
    const ws = utils.json_to_sheet([]);
    utils.sheet_add_aoa(ws, xlsHeadings);
    utils.sheet_add_aoa(
      ws,
      [["Споживання, кВт*год"].concat(props.consumption)],
      {
        origin: "A2",
        skipHeader: true,
      }
    );
    {
      props.cost &&
        utils.sheet_add_aoa(ws, [["Вартість"].concat(props.cost)], {
          origin: "A3",
          skipHeader: true,
        });
    }

    utils.book_append_sheet(wb, ws, "consumption");
    writeFile(wb, `${props.title} .xlsx`);
  };

  return (
    <div className="general-info__chart">
      <div className="chart">
        <div className="chart__yaxes">
          <Bar data={data2} options={options2} />
        </div>

        <div className={props.className} ref={ref}>
          <div
            className={
              props?.xAvis?.length < 25 ? "chart__wrap" : "chart__wrap-scroll"
            }
          >
            <Bar data={data} options={options} redraw={true} />
          </div>
        </div>

        <div className="chart__yaxes2">
          <Bar data={data3} options={options3} />
        </div>
      </div>
      <div className="chart__bottom">
        <div className="chart__legend">
          <div className="chart__legend-list ">
            {props.cost && (
              <div className="chart__legend-item chart__legend-item--plan">
                <span></span>
                Вартість, грн
              </div>
            )}
            <div className="chart__legend-item chart__legend-item--fact">
              <span></span>
              Споживання, кВт*год
            </div>
          </div>
        </div>
        {props.button ? (
          <div className="general-info__chart-button">
            <Button
              text={props.button}
              className="button button__excel"
              sendRequest={handleExport}
            ></Button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ChartTarrifStructure;
